import cartOptions from '../../coto_scripts/cart/cart-slide';

export default {
  //  name: 'topNavigation',
  name: 'navError',
  components: {},
  mixins: [],
  props: [],
  setup() {
    return {};
  },
  data() {},
  computed: {},
  methods: {
    //Core cart functions
    cartToggle() {
      let sideCartClassList = document.getElementById('sidecart').classList;
      if (sideCartClassList.contains('sidecart-open')) {
        //this.closeCart();
        e.stopPropagation();
        $('.coto_header').removeClass('cart-squish');
        cartOptions.closeCart();
      } else {
        e.stopPropagation();
        $('.dropper').removeClass('active');
        $('.level-2').removeClass('dropOpen');
        $('.drop-menu').removeClass('active');
        $('.top-nav').removeClass('menuOpen');
        $('.coto_header').addClass('cart-squish');
        cartOptions.openCart();
        //this.openCart();
      }
    },
  },
  mounted() {},
};
